import React from 'react';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { CTASection } from '../components/CTASection';
export const HowItWorksPage = () => {
  return <div className="pt-8" data-id="element-256">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 mb-12" data-id="element-257">
        <h1 className="text-4xl font-bold text-gray-900 mb-4 text-center" data-id="element-258">
          Our Process
        </h1>
        <p className="text-xl text-gray-600 text-center max-w-3xl mx-auto" data-id="element-259">
          From job posting to onboarding, we streamline every step of your sales
          recruitment.
        </p>
      </div>
      <HowItWorksSection data-id="element-260" />
      <CTASection data-id="element-261" />
    </div>;
};